export const SORT = {
    1: '倒序',
    2: '正序'
}

export const SORT_TYPE = {
    1: '安装时间',
}

export const PLACE_STATUS = {
    0: '全部状态',
    1: '只看正常',
}